import React, { useState, useEffect } from 'react';
import Header from '@/components/common/header/DefaultHeader';
import MobileMenu from '@/components/common/header/MobileMenu';
import Footer from '@/components/common/footer/Footer';
import { getWebCMS } from '@/api/PDP';
import ReactHtmlParser from "react-html-parser";
import "./CashIncentives.css"
import OtherLinkFooter from '../common/footer/OtherLinkFooter';
import NewFooter from '../common/footer/NewFooter';

const CashIncentives = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [cmsData, setCmsData] = useState('');

  useEffect(() => {
    getWebCMS("pages/cashIncentive").then((response) => {
      setCmsData(response?.results[0]);
      console.log("cashIn", cmsData);
    });
  }, []);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const data = [
    {
      state: cmsData?.stateByStateProperty?.property1?.state,
      purchasePrice1: cmsData?.stateByStateProperty?.property1?.price1Less,
      purchasePrice2: cmsData?.stateByStateProperty?.property1?.price2Less,
      purchasePrice3: cmsData?.stateByStateProperty?.property1?.price1More,
      purchasePrice4: cmsData?.stateByStateProperty?.property1?.price2More,
    },
    {
      state: 'MA/NJ/NY',
      purchasePrice1: '$5,500',
      purchasePrice2: '$7,500',
      purchasePrice3: '$7,500',
      purchasePrice4: '$7,500',
    },
    // Add the remaining data entries here
  ];

  return (
    <div>
      <Header />
      <MobileMenu />
      <header
        className="stricky-fixed"
      >
      </header>
      <div className="container-fluid p-0">
        <div className="row no-gutters">
          <div className="cash-in-banner col-12 position-relative d-flex align-items-center">
            {/* {!imageLoaded && (
              <div className="loader-container position-absolute w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
                <TailSpin height="80" width="80" color="#fff" ariaLabel="loading" />
              </div>
            )}
            <img src="https://image-prod.hubzu.com/landingpage/cash-incentive/images/Background-Image.png" alt="CyberMonday" className="img-fluid w-100 h-100 position-absolute" style={{ objectFit: "cover", top: "0", left: "0", zIndex: "-1" }} onLoad={handleImageLoad} /> */}
            <div className="container cash-in d-flex flex-column justify-content-center align-items-start text-white" style={{ zIndex: "1" }}>
              <h1 className="mb-3">{cmsData?.bannerSection?.header1}<br />{cmsData?.bannerSection?.header2}</h1>
              <h3 className="mb-3">Upto <span style={{ fontWeight: 700 }}>{cmsData?.bannerSection?.subHeader1}</span><span>{cmsData?.bannerSection?.incentiveValue}</span>
                {cmsData?.bannerSection?.subHeader2}
              </h3>
              <button className="btn btn-lg booking_btn btn-thm"><a href="/auctions?searchBy=All%20States&offers=cash-incentive&campaignId=7602f038-74e6-4441-af7d-66e9146d5efd&campaignType=DYNAMIC" target="_blank">View Select Properties</a></button>
              {/* <button className="btn btn-lg booking_btn btn-thm"><a href={cmsData?.viewPropertiesLink}>View Select Properties</a></button> */}
            </div>
          </div>
        </div>
      </div>

      <div className="cash-in-intro container d-flex flex-column justify-content-center align-items-start text-white">
        <div className="pt70 pb50">
          <h2 className="mb-3 text-start">{cmsData?.newPropertySection?.header}</h2>
          <p className="mb-3 text-start">{ReactHtmlParser(cmsData?.newPropertySection?.description1)}</p>
          <p className="mb-3 text-start">{cmsData?.newPropertySection?.description2}</p>
          <p className="mb-3 text-start">{cmsData?.newPropertySection?.description3}</p>
        </div>
      </div>

      {/* <section className="view-prop-table">
        <div className="container d-flex flex-column justify-content-center align-items-start py-3">
          <div className='title-btn-cont'>
              <div className='mb-2 mb-md-0 '>
                <div className='view-prop-table-title'>{cmsData?.stateByStateProperty?.header}</div>
              </div>
              <div className='text-md-right'>
                <button className="btn btn-lg booking_btn btn-thm"><a href="auctions?searchBy=All%20States&offers=cash-incentive&campaignId=7602f038-74e6-4441-af7d-66e9146d5efd&campaignType=DYNAMIC" target="_blank">View Properties Now</a></button>
              </div>
          </div>
           <Row className="align-items-center">
            <Col xs={12} md={9} className="mb-2 mb-md-0">

            </Col>
            <Col xs={12} md={3} className="text-md-right">

            </Col>
          </Row> 
          <div className="">
             <table className="incentive-table pb30">
              <tbody>
                <tr>
                  <td className="table-header top-left-cornner incentiveBreakDown">State</td>
                  <td className="table-header incentiveBreakDown">Purchase Price $250,000 or <span className="show">less</span></td>
                  <td className="table-header top-right-cornner incentiveBreakDown">Purchase Price $250,001 or more</td>
                </tr>
                <tr>
                  <td className="incentiveBreakDown">
                    <div className="tableLocation"><strong>MA/NJ/<span>NY</span></strong></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$5,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$2,750</span></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$7,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$3,750</span></div>
                  </td>
                </tr>
                <tr>
                  <td className="incentiveBreakDown">
                    <div className="tableLocation"><strong>HI</strong></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$4,700</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$2,350</span></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$6,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$3,250</span></div>
                  </td>
                </tr>
                <tr>
                  <td className="incentiveBreakDown">
                    <div className="tableLocation"><strong>IL/MD/<span>PA</span></strong></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$4,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$2,250</span></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$7,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$3,750</span></div>
                  </td>
                </tr>
                <tr>
                  <td className="incentiveBreakDown">
                    <div className="tableLocation"><strong>CT</strong></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$3,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$1,750</span></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$7,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$3,750</span></div>
                  </td>
                </tr>
                <tr>
                  <td className="incentiveBreakDown">
                    <div className="tableLocation"><strong>NH</strong></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$3,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$1,750</span></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$6,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$3,250</span></div>
                  </td>
                </tr>
                <tr>
                  <td className="incentiveBreakDown">
                    <div className="tableLocation"><strong>AK/CA/<span>DC/NM/</span><span>OR/WA</span></strong></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$3,200</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$1,600</span></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$6,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$3,250</span></div>
                  </td>
                </tr>
                <tr>
                  <td className="incentiveBreakDown">
                    <div className="tableLocation"><strong>ID/ND/<span>RI</span></strong></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$2,850</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$1,425</span></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$6,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$3,250</span></div>
                  </td>
                </tr>
                <tr>
                  <td className="incentiveBreakDown">
                    <div className="tableLocation"><strong>AL/AZ/<span>MT/NE</span></strong></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$2,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$1,250</span></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$6,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$3,250</span></div>
                  </td>
                </tr>
                <tr>
                  <td className="incentiveBreakDown">
                    <div className="tableLocation"><strong>NV/WV</strong></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$2,200</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$1,100</span></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$6,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$3,250</span></div>
                  </td>
                </tr>
                <tr>
                  <td className="incentiveBreakDown">
                    <div className="tableLocation"><strong>DE/ME/<span>VT</span></strong></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$1,700</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$1,000</span></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$6,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$3,250</span></div>
                  </td>
                </tr>
                <tr>
                  <td className="incentiveBreakDown">
                    <div className="tableLocation">OTHER STATES</div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$1,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$1,000</span></div>
                  </td>
                  <td className="incentiveBreakDown">
                    <div className="tableClose">close within 30 days <span className="tableMoney">$6,500</span></div>
                    <div className="tableClose">close within 60 days <span className="tableMoney">$3,250</span></div>
                  </td>
                </tr>
              </tbody>
            </table> 
           
          </div>
        </div>
      </section> */}
      <section>
         <div className="container d-flex flex-column justify-content-center align-items-start py-3" style={{borderBottom: "solid 1px lightgrey"}}>
         <div className="incentive-disclaimer">
              <div className="mb-1" style={{color:"#000"}}><strong>Disclaimer:</strong></div>
              <p>*The cash incentive on select occupied properties, credited to the buyer by the seller at closing, will be reflected on the settlement statement and will only be applied if the following conditions are met:
              </p>
              <ul type="square">
                <li>The buyer must close within the timeframe specified in the purchase and sale agreement (PSA), generally within 30 or 60 days from contract execution. </li>
                <li>The incentive amount is determined by the seller and may vary based on both the seller and the actual closing date.</li>
                <li>The seller does not have an active cash-for-relocation agreement in place with the current occupant as of the date the seller and the selected bidder sign the PSA.</li>
              </ul>
            </div>
            </div>
      </section>

      {/* <section className="footer_one home6 bg-ptrn2">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> */}
         <div className="container-fluid px-0">
                      {/* <Footer /> */}
                      <OtherLinkFooter/>
                      <NewFooter/>
                  </div>

    </div>
  );
};

export default CashIncentives;
